import React from "react";
import { Link, useLocation } from "react-router-dom";
import { trackEvent } from "../utils/analytics";

import ExploreIcon from "./ExploreIcon";
import HomeIcon from "./HomeIcon";
import ProfileIcon from "./ProfileIcon";
import ReelIcon from "./ReelIcon";

const navItems = [
  {
    label: "Home",
    icon: <HomeIcon style={{ width: 24, height: 24 }} />,
    to: "/",
  },
  {
    label: "Xplore",
    icon: <ExploreIcon style={{ width: 22, height: 22 }} />,
    to: "/products",
  },
  {
    label: "Reels",
    icon: <ReelIcon style={{ width: 28, height: 28 }} />,
    to: "/reels",
  },
  {
    label: "Profile",
    icon: <ProfileIcon style={{ width: 22, height: 22 }} />,
    to: "/profile",
  },
];

const BottomNavBar = () => {
  const location = useLocation();

  return (
    <nav
      className="bottom-nav-bar fixed bottom-4 left-1/2 -translate-x-1/2
        z-30
        w-[calc(100vw-8px)] max-w-none
        h-[78px]
        px-2
        bg-white/95 backdrop-blur-md
        border border-gray-200
        rounded-2xl
        shadow-2xl shadow-black/20
        grid grid-cols-4 items-center
        md:hidden"
      style={{
        zIndex: 30,
        paddingTop: "8px",
        paddingBottom: "8px",
      }}
    >
      {navItems.map((item) => {
        const isActive = location.pathname === item.to;

        return (
          <Link
            key={item.label}
            to={item.to}
            className={`flex w-full min-w-0 flex-col items-center justify-center text-xs font-semibold leading-tight transition-colors ${
              isActive ? "text-pink-600" : "text-gray-600 hover:text-pink-500"
            }`}
            onClick={() =>
              trackEvent("bottom_nav_click", {
                label: item.label,
                path: item.to,
              })
            }
          >
            {item.icon}
            <span className="mt-1 block text-[11px] leading-none">
              {item.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNavBar;
